module.exports = require('./helpers/bundle-url').getBundleURL('koVhS') + "Heart.782b0c7a.svg";